<script lang="ts">
    import { theme } from '$theme/theme.svelte';
    export let fill = $theme.colors.semantic.success[500];
    // width="16" height="17"
</script>

<svg {...$$restProps} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.6666 8.75883C14.6666 12.4407 11.6819 15.4255 7.99998 15.4255C4.31808 15.4255 1.33331 12.4407 1.33331 8.75883C1.33331 5.07693 4.31808 2.09216 7.99998 2.09216C11.6819 2.09216 14.6666 5.07693 14.6666 8.75883ZM10.6869 6.73861C10.8821 6.93387 10.8821 7.25045 10.6869 7.44572L7.35353 10.7791C7.15827 10.9743 6.84169 10.9743 6.64643 10.7791L5.31309 9.44572C5.11783 9.25045 5.11783 8.93387 5.31309 8.73861C5.50836 8.54335 5.82494 8.54335 6.0202 8.73861L6.99998 9.71839L8.48987 8.2285L9.97976 6.73861C10.175 6.54335 10.4916 6.54335 10.6869 6.73861Z"
        {fill}
    />
</svg>
